import { Grid, Theme, useTheme, Tooltip, Typography } from "@mui/material";
import { IFlightATA } from "@vmosolutions/oc-interfaces";

export interface IATACodeChip {
  flightATA: IFlightATA;
  showFullName?: boolean;
}

const ataCodeChipStyles = (theme: Theme): any => ({
  height: 20,
  display: "flex",
  margin: "2px",
  borderRadius: "3px",
  fontFamily: "B612 Mono, arial, sans-serif",
  fontSize: 12,
  padding: "5px",
  alignItems: "center",
  backgroundColor: theme.palette.grey[300],
  color: theme.palette.background.paper,
});

export const ATACodeChip = (props: IATACodeChip): JSX.Element => {
  const { flightATA, showFullName } = props;
  const theme: Theme = useTheme();

  if (!flightATA?.ataNumber || !flightATA?.ataCode?.code) return null;
  const numberCode = flightATA?.ataNumber?.concat(flightATA?.ataCode?.code);
  const tooltip = numberCode.concat("-", flightATA?.ataCode?.description);

  return (
    <Grid item sx={ataCodeChipStyles(theme)}>
      {showFullName ? (
        <Typography variant="caption">{tooltip}</Typography>
      ) : (
        <Tooltip title={tooltip ?? ""} placement="top">
          <Typography variant="caption">{numberCode}</Typography>
        </Tooltip>
      )}
    </Grid>
  );
};
